import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Trumps Airport · Your Gateway to the Skies</p>
        <h1>Welcome to Trumps Airport.</h1>
        <p className="lede">
          Experience seamless travel with our state-of-the-art facilities and exceptional service. 
          Your journey begins here, where comfort meets convenience.
        </p>
        <div className="cta-row">
          <a href="/flights" target="_blank">
            Explore Flights
          </a>
          <a href="/services" target="_blank" className="secondary">
            Discover Our Services
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Effortless Check-In</h2>
          <p>
            Enjoy a smooth check-in process with our user-friendly kiosks and dedicated staff ready to assist you.
          </p>
        </article>
        <article>
          <h2>Premium Amenities</h2>
          <p>
            Relax in our lounges, dine at top-notch restaurants, and shop at exclusive stores before your flight.
          </p>
        </article>
        <article>
          <h2>Real-Time Updates</h2>
          <p>
            Stay informed with real-time flight updates and notifications, ensuring you never miss a beat.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;